import { useContext, useState, useEffect } from 'react';
import { Icon } from 'semantic-ui-react';

import Dropdown from '../common/Dropdown';

import { AnnotationContext } from '../context/AnnotationContext';

import { ANNOTATIONS_COUNT } from '../models/Annotation';

import Annotation from '../models/Annotation';


import '../stylesheets/annotation-details.scss';

const strokeTypeOptions = [
    'serve',
    'forehand',
    'backhand',
    'volley',
    'overhead'
]

const strokeSpinOptions = [
    'flat',
    'slice',
    'topspin'
]

const courtSideOptions = [
    'near',
    'far'
]

//Ball_bounce label and attributes
const longitudeRegionOptions = [
    'service_box',
    'no_mans_land',
    'out'
]

const latitudeRegionOptions = [
    'deuce_out',
    'deuce_alley',
    'deuce',
    'center_line',
    'ad',
    'ad_alley',
    'ad_out'
]

const trackOptions = [
    'host',
    'host_partner',
    'opponent',
    'opponent-partner'
]

export const labelToAttributesMap = {
    ball_hit: {
        stroke_type: strokeTypeOptions,
        stroke_spin: strokeSpinOptions,
        court_side: courtSideOptions,
    },
    ball_bounce: {
        longitude_region: longitudeRegionOptions,
        latitude_region: latitudeRegionOptions,
        court_side: courtSideOptions,
    },
    player: {
        track: trackOptions,
    }
};

/**
 * Component for displaying the details of an annotation
 *
 * @param {Annotation} annotation - The Annotation object to display
 * @param {Number}     index      - Index of the Annotation
 */
function AnnotationDetails({ annotation, index }) {
    // Initialize label to ball_hit
    const [selectedLabel, setSelectedLabel] = useState('ball_hit')
    const [attributeOptions, setAttributeOptions] = useState(
        labelToAttributesMap[selectedLabel]
    );
    const annotationContext = useContext(AnnotationContext)

    // id should match to the image name, the format of 00XX.jpg
    const id = annotationContext.imageSrc.slice(-8)
    const isSelected = annotation === annotationContext.selectedAnnotation


    function handleDeleteKeyDown(event) {
        if (event.key === 'Delete') {
            annotationContext.deleteAnnotation(index)
        }
    }

    const handleLabelChange = (label) => {
        setSelectedLabel(label)
        updateAnnotation(label)
    };

    // Tried extension #1

    function handleCopy() {
        const {id, x0, y0, x1, y1, title, label, attributes, testId, newId} = annotation;
        const newAnnotation = new Annotation(x0, y0, x1, y1);
        newAnnotation.id = id;
        newAnnotation.title = title;
        newAnnotation.label = label;
        newAnnotation.testId =  testId;
        newAnnotation.newId = newId;
        newAnnotation.attributes = {...attributes}; // Using spread operator to copy the attributes object
        annotationContext.addAnnotation(newAnnotation);
        annotationContext.setSelectedAnnotation(newAnnotation);
    }

    console.log("copied", annotation);


    useEffect(() => {
        setAttributeOptions(labelToAttributesMap[selectedLabel])
        annotation && setSelectedLabel(annotation.label || 'ball_hit')
    }, [selectedLabel])

    // Show annotation title corresponding to the selected label
    const updateAnnotation = (label) => {
        annotation.label = label;
        switch (label) {
            case 'ball_hit':
                annotation.title = `Ball Hit ${ANNOTATIONS_COUNT}`
                break;
            case 'ball_bounce':
                annotation.title = `Ball Bounce ${ANNOTATIONS_COUNT}`
                break;
            case 'player':
                annotation.title = `Player ${ANNOTATIONS_COUNT}`
                break;
            default:
                annotation.title = `Annotation ${ANNOTATIONS_COUNT}`
        }
        annotation.id = id
    }

    // tabIndex, onKeyDown: keyboard focus and x-button keyboard accessible
    return (
        annotation &&
        <div className={`ui card annotation-details ${isSelected ? 'selected' : ''}`}
            //It triggers bug #2
             onClick={() => annotationContext.setSelectedAnnotation(annotation)}
             onKeyDown={handleDeleteKeyDown}
             tabIndex="0"
        >
            <div className="ui vertically padded grid annotation-title">
                <p>{annotation['title']}</p>
                {/*<Icon className="x-button" name='close' onClick={(e) => {*/}
                {/*    //It fixes bug #2*/}
                {/*    e.stopPropagation();*/}
                {/*    annotationContext.deleteAnnotation(index)*/}
                {/*}} />*/}

                {/*  Tried extension #1*/}
                <div className="icon_container">
                    <Icon id="copy_icon" name="copy" size="large"
                          onClick={handleCopy}
                    />
                    <Icon className="x-button" name='close' onClick={(e) => {
                        //It fix bug #2
                        e.stopPropagation()
                        annotationContext.deleteAnnotation(index)
                    }} />
                </div>
            </div>
            <p>Label: {selectedLabel}</p>
            <Dropdown
                title='label'
                options={Object.keys(labelToAttributesMap)}
                annotation={annotation}
                selectedValue={selectedLabel}
                onSelectedValueChange={handleLabelChange}
                label = {selectedLabel}
            />
            <p>Attributes: </p>
            {Object.entries(attributeOptions).map(([title, options]) => (
                <Dropdown
                    key={title}
                    title={title}
                    options={options}
                    annotation={annotation}
                    label = {selectedLabel}
                />
            ))}
        </div>
    )
}

export default AnnotationDetails
